import styled, { css } from 'styled-components';

// Import styles utilities
import { flex, customMinResponsive, size } from 'components/styles';

// Import components
import { Button } from 'components/elements/atoms/Button/Button';

export const OuterWrapper = styled.div`
	${flex({ fd: 'column' })}

	${customMinResponsive(
		size.xsmall,
		css`
			${flex()}
		`
	)}
`;

export const Wrapper = styled.div`
	width: 22rem;
	${flex({ jc: 'space-between', fd: 'column' })}
	box-sizing: border-box;
	border: 1px solid ${({ theme }) => theme.paleGreen};
	border-radius: 0.4rem;
	background: transparent;
	outline: none;
	cursor: pointer;
	margin: 0 0 1rem 0;

	${customMinResponsive(
		size.xsmall,
		css`
			${flex({ jc: 'space-between' })}
			height: 3.9rem;
			margin: 0 1.2rem 0 0;
		`
	)}
`;

export const Container = styled.div`
	align-items: center;
`;

export const GradientButton = styled.button`
	font-weight: ${({ theme }) => theme.font.bold};
	text-align: center;
	border: 0;
	cursor: pointer;
	box-shadow: none;
	background: ${({ theme }) => theme.menu.button.color};
	border-radius: ${({ theme }) => theme.menu.button.radius};
	color: ${({ theme }) => theme.white};
	width: 9.4rem;
	min-height: 100%;
	font-size: 1.1rem;
	&:disabled {
		opacity: 0.5;
	}
`;

export const Content = styled.p`
	text-align: left;
	padding: 1.1rem 0 1.1rem 1.3rem;
	color: ${({ theme, isPlaceholder }) => (isPlaceholder ? theme.palette.secondary.dark : theme.palette.white)};
	font-weight: ${({ theme }) => theme.font.normal};
	font-size: 1.4rem;
	cursor: pointer;
`;

export const Buttons = styled.div`
	column-gap: 1rem;
`;

export const AttachmentButton = styled(Button)`
	width: 9.4rem;
`;
